'use client';

import {
  Stack,
  Toast,
  Portal,
  Spinner,
  createToaster,
  Toaster as ChakraToaster,
} from '@chakra-ui/react';

import type { JSX } from 'react';

export const toaster: ReturnType<typeof createToaster> = createToaster({
  pauseOnPageIdle: true,
  placement: 'bottom-end',
});

export function Toaster(): JSX.Element {
  return (
    <Portal>
      <ChakraToaster
        toaster={toaster}
        insetInline={{
          mdDown: '4',
        }}
      >
        {(toast) => {
          return (
            <Toast.Root
              width={{
                md: 'sm',
              }}
            >
              {toast.type === 'loading' ? (
                <Spinner size='sm' color='blue.solid' />
              ) : (
                <Toast.Indicator />
              )}
              <Stack gap='1' flex='1' maxWidth='100%'>
                {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
                {toast.description && (
                  <Toast.Description>{toast.description}</Toast.Description>
                )}
              </Stack>
              {toast.action && (
                <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>
              )}
              {toast.meta?.closable && <Toast.CloseTrigger />}
            </Toast.Root>
          );
        }}
      </ChakraToaster>
    </Portal>
  );
}
